export default function QuestionsIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 11 6" xmlns="http://www.w3.org/2000/svg">
        <path d="m9.4902 0.22904c0.34378-0.30539 0.90729-0.30539 1.2511 0 0.1736 0.15427 0.2587 0.35576 0.2587 0.55726 0 0.2015-0.0851 0.403-0.2587 0.55726l-5.2417 4.6564-1.2511-1.1145-3.9907-3.5419c-0.34378-0.30854-0.34378-0.80599 0-1.1145 0.34732-0.30539 0.90729-0.30539 1.2546 0l3.9907 3.5419 3.9871-3.5419z"/>
      </svg>
    </>
  );
}